export default {
    inviteStatictis: "/gateway/huilianOperation/invitecs/inviteStatictis", //拉新奖励统计
    selectInviteList: "/gateway/huilianOperation/invitecs/selectInviteList", //拉新列表查询
};



// WEBPACK FOOTER //
// ./src/inviteNewUsers/detail/api.js